import React from 'react';

const ProfileContext = React.createContext({});

export default ProfileContext;
